export type TranscriptionDocumentState = 'created' | 'in_progress' | 'completed' | 'error'

export type TranscriptionDocumentMetadata = {
    customerId: number
    customerName: string
    transcriptState: TranscriptionDocumentState
    documentTitle: string
    uploadedAt: Date
    fileUrl?: string
    generativeAiEnabled?: boolean
}

export type TranscriptionDocumentMetadataJSON = {
    customer_id: number
    customer_name: string
    transcript_state?: TranscriptionDocumentState
    /**
     * Backward-compatibility for environments still returning `status`.
     */
    status?: TranscriptionDocumentState
    name: string // document title
    uploaded_at: string
    url?: string
    generative_ai_enabled?: boolean
}

export const toTranscriptionDocumentMetadata = (json: TranscriptionDocumentMetadataJSON): TranscriptionDocumentMetadata => {
    const transcriptState = json.transcript_state ?? json.status ?? 'in_progress'

    return {
        customerId: json.customer_id,
        customerName: json.customer_name,
        transcriptState,
        documentTitle: json.name,
        uploadedAt: new Date(json.uploaded_at),
        fileUrl: json.url,
        generativeAiEnabled: Boolean(json.generative_ai_enabled),
    }
}

export const isDocumentFinished = (metadata: TranscriptionDocumentMetadata) => metadata.transcriptState === 'completed'
